import { PAGE_TYPE_HOMEPAGE, TENANT_CH } from 'shared/consts'
import { REDCARE_INFO_MODAL_CH } from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import store from 'shared/store'

const REDCARE_INFO_MODAL_ID = 'RedcareInfoModal'

const triggerRedcareInfoModal = () => {
  setTimeout(function () {
    window.location.hash = REDCARE_INFO_MODAL_ID
    window.sessionStorage.setItem(REDCARE_INFO_MODAL_ID, 'true')
    window._uxa = window._uxa || []
    window._uxa.push([
      'trackPageview',
      `${window.location.pathname}${window.location.hash.replace('#', '/__')}`,
    ])
  }, 2000)
}

const getIsSourceBlacklisted = (
  expa: string | undefined,
  searchUrl: string | undefined
) => {
  if (expa !== 'ggl' || !searchUrl || searchUrl?.includes('Redcare'))
    return true

  return (
    !searchUrl.includes('adword=google/S_de-CH_Branded_Exact/Brand_exact') &&
    !searchUrl.includes('adword=google/S_fr-CH_Branded_Exact/Brand_exact') &&
    !searchUrl.includes('adword=google/S_de-CH_Branded/Gen_Shop-Apotheke')
  )
}

export default () => {
  const isRedcareInfoModalShown = window.sessionStorage.getItem(
    REDCARE_INFO_MODAL_ID
  )
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { tenant } = publicRuntimeConfig?.publicConfig || {}
  const {
    experiments = [],
    pageType = '',
    expa,
    searchUrl,
  } = publicRuntimeConfig?.pageProperties || {}
  const isSourceBlacklisted = getIsSourceBlacklisted(expa, searchUrl)

  if (
    tenant !== TENANT_CH ||
    isSourceBlacklisted ||
    isRedcareInfoModalShown ||
    pageType !== PAGE_TYPE_HOMEPAGE
  ) {
    return
  }

  const redcareModalExperiment = getExperiment(
    REDCARE_INFO_MODAL_CH,
    experiments
  )

  if (redcareModalExperiment.isEnabled) {
    triggerRedcareInfoModal()
  }
}
